import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";

import { TransactionStatusEnum } from "../../enums/payment";

import { PLANS_QUERY_KEYS } from "../queryKeys";
import { getInvoices } from "../services/paymentTransactions";

export const useGetInvoices = (
  userId: number | undefined,
  limit: number,
  offset: number,
  status: TransactionStatusEnum | "ALL"
) => {
  const { i18n } = useTranslation();

  return useQuery({
    queryKey: [...PLANS_QUERY_KEYS.INVOICES, userId, limit, offset, i18n.language, status],
    queryFn: () => {
      const normalizedStatus = status === "ALL" ? null : status;
      return getInvoices(userId!, limit, offset, normalizedStatus);
    },
    enabled: !!userId,
  });
};
